import type { SiteListFilters, SiteFilterParams } from "./useSiteList";

/**
 * Фильтры экрана «Сайты» в виде тела запроса: в объект попадают только
 * заполненные поля, пустые не отправляются вовсе — так бэкенд отличает
 * «фильтр не задан» от «задан пустым».
 */
export function buildSiteFilterObject(filters: SiteListFilters): SiteFilterParams {
  const parameters: SiteFilterParams = {};
  if (filters.search) {
    parameters.search = filters.search;
  }
  if (filters.region) {
    parameters.region = filters.region;
  }
  if (filters.seller) {
    parameters.seller = filters.seller;
  }
  if (filters.siteType !== undefined) {
    parameters.siteType = filters.siteType;
  }
  if (filters.accessValidity !== undefined) {
    parameters.accessValidity = filters.accessValidity;
  }
  if (filters.articleXmlRpcStatus !== undefined) {
    parameters.articleXmlRpcStatus = filters.articleXmlRpcStatus;
  }
  if (filters.articleApiStatus !== undefined) {
    parameters.articleApiStatus = filters.articleApiStatus;
  }
  if (filters.articleWpAdminStatus !== undefined) {
    parameters.articleWpAdminStatus = filters.articleWpAdminStatus;
  }
  if (filters.homepageApiStatus !== undefined) {
    parameters.homepageApiStatus = filters.homepageApiStatus;
  }
  if (filters.homepageWpAdminStatus !== undefined) {
    parameters.homepageWpAdminStatus = filters.homepageWpAdminStatus;
  }
  if (filters.linkRemovalApiStatus !== undefined) {
    parameters.linkRemovalApiStatus = filters.linkRemovalApiStatus;
  }
  if (filters.linkRemovalXmlRpcStatus !== undefined) {
    parameters.linkRemovalXmlRpcStatus = filters.linkRemovalXmlRpcStatus;
  }
  if (filters.linkRemovalWpAdminStatus !== undefined) {
    parameters.linkRemovalWpAdminStatus = filters.linkRemovalWpAdminStatus;
  }
  if (filters.pluginArticleStatusFilter !== undefined) {
    parameters.pluginArticleStatusFilter = filters.pluginArticleStatusFilter;
  }
  if (filters.pluginHomepageStatusFilter !== undefined) {
    parameters.pluginHomepageStatusFilter = filters.pluginHomepageStatusFilter;
  }
  if (filters.pluginSitewideStatusFilter !== undefined) {
    parameters.pluginSitewideStatusFilter = filters.pluginSitewideStatusFilter;
  }
  if (filters.pluginLinkRemovalStatusFilter !== undefined) {
    parameters.pluginLinkRemovalStatusFilter = filters.pluginLinkRemovalStatusFilter;
  }
  if (filters.dateFrom) {
    parameters.dateFrom = filters.dateFrom;
  }
  if (filters.dateTo) {
    parameters.dateTo = filters.dateTo;
  }
  if (filters.minArticlePostsCount) {
    parameters.minArticlePostsCount = Number(filters.minArticlePostsCount);
  }
  if (filters.minHomepagePostsCount) {
    parameters.minHomepagePostsCount = Number(filters.minHomepagePostsCount);
  }
  if (filters.maxArticleAttemptErrors) {
    parameters.maxArticleAttemptErrors = Number(filters.maxArticleAttemptErrors);
  }
  if (filters.maxHomepageAttemptErrors) {
    parameters.maxHomepageAttemptErrors = Number(filters.maxHomepageAttemptErrors);
  }
  if (filters.withoutParams) {
    parameters.withoutParams = true;
  }
  return parameters;
}
